class ComponentDrawerReviewsSlider extends Theme.Component {
  constructor() {
    super();

    this.slider = null;
    this.lastWidth = 0;
    this.isBuilding = false;
    this.resizeObserver = null;
  }

  connectedCallback() {
    this.sliderElement = this.querySelector(".drawer-reviews__slider");
    this.sliderItems = this.querySelectorAll(".drawer-reviews__cell");

    if (!this.sliderElement || this.sliderItems.length === 0) return;

    requestAnimationFrame(() => this.observe());
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }

    this.teardown();
  }

  observe() {
    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const width = Math.round(entry.contentRect.width);

        if (width <= 0 || width === this.lastWidth) continue;
        this.lastWidth = width;

        if (this.isBuilding) continue;
        this.isBuilding = true;

        this.teardown();
        this.setup();
        this.isBuilding = false;
      }
    });

    this.resizeObserver.observe(this.sliderElement);
  }

  setup() {
    if (!this.sliderElement || typeof Flickity === "undefined") return;

    this.sliderItems.forEach((element) => {
      element.style.height = "auto";
    });

    this.slider = new Flickity(this.sliderElement, {
      cellAlign: "left",
      contain: true,
      pageDots: this.sliderItems.length > 1,
      prevNextButtons: this.sliderItems.length > 1,
      wrapAround: false,
      dragThreshold: 10,
      selectedAttraction: 0.08,
      friction: 0.4,
    });

    this.sliderItems.forEach((element) => {
      element.style.height = "100%";
    });
  }

  teardown() {
    if (!this.slider) return;

    this.slider.destroy();
    this.slider = null;

    this.sliderItems.forEach((element) => {
      element.style.height = "auto";
    });
  }

  refresh() {
    if (this.slider) {
      this.slider.resize();
      this.slider.reposition();
      return;
    }

    const width = Math.round(this.sliderElement?.getBoundingClientRect().width || 0);
    if (width > 0) {
      this.lastWidth = width;
      this.setup();
    }
  }
}

customElements.define("component-drawer-reviews-slider", ComponentDrawerReviewsSlider);
